import { useQuery } from "@tanstack/react-query";
import { apiClient, ApiError } from "@/lib/api-client";

/**
 * Shape of GET /api/auth/me. The backend returns `{ local: true }` when
 * running outside Cloud Run (local-dev auth bypass), otherwise the
 * authenticated identity.
 */
export interface AuthMe {
  local?: boolean;
  authenticated?: boolean;
}

export const authMeQueryKey = ["auth", "me"] as const;

export function useAuth() {
  const query = useQuery<AuthMe>({
    queryKey: authMeQueryKey,
    queryFn: () => apiClient.get<AuthMe>("/auth/me"),
    retry: false,
    staleTime: 5 * 60 * 1000,
  });

  // {local: true} counts as authenticated (dev bypass), as does an
  // explicit authenticated flag.
  const isAuthenticated = query.data?.local === true || query.data?.authenticated === true;

  const isUnauthenticated = query.isError && query.error instanceof ApiError && query.error.status === 401;

  return {
    ...query,
    isAuthenticated,
    isUnauthenticated,
  };
}
